<div class="story-list" [ngClass]="{
      'story-list__largeDesktop': (responsiveService.isLargeDesktopScreen$ | async) === true,
      'story-list__tablet': (responsiveService.isTabletScreen$ | async) === true,
      'story-list__mobile': (responsiveService.isMobileScreen$ | async) === true
      }">
  @for (story of displayedStories; track story.id) {
    <mat-card appearance="outlined" class="story-card" [routerLink]="'/story/' + (story.url || story.id)">
      <mat-chip-set class="story-theme-container" aria-label="Theme list">
        @for (theme of story.themeList; track theme.id) {
          <mat-chip class="story-theme">
            <span style="font-size: 0.7rem;">{{ theme.name || '-' }}</span>
          </mat-chip>
        }
      </mat-chip-set>
      <img mat-card-image [src]="story.headerImage.thumbnailUrl || '/nopicture.png'" [alt]="story.headerImage.name"/>
      <mat-card-content>
        <div class="w-100 d-flex flex-row justify-content-between mt-3">
          <div class="story-location d-flex flex-wraps align-items-start">
            <mat-icon fontSet="material-symbols-outlined" style="min-width: 16px;">
              @if (story.isProject) {
                flag
              } @else {
                location_on
              }
            </mat-icon>&nbsp;
            <span style="word-break: break-word">{{ story.neighbourhood.name }}</span>
          </div>
          <div class="story-location d-flex flex-wraps align-items-start">
            <mat-icon fontSet="material-symbols-outlined">
              tag
            </mat-icon>{{ story.collectionNumber }}
          </div>
        </div>
        <h4 class="text-primary-dark arbutus my-2">
          {{ story.title || '-' }}
        </h4>
        <span class="story-description">
          {{ story.shortDescription.length > 120 ? story.shortDescription.slice(0, 120) + '…' : story.shortDescription }}
        </span>
      </mat-card-content>
    </mat-card>
  }

  <!-- Sentinel element for Intersection Observer -->
  @if (hasMoreStories) {
    <div #sentinel style="height: 1px;"></div>
  }
</div>
